import path from 'path'
import fs from 'fs-extra'
import * as ERRORS from '@/src/utils/errors'

export async function preFlight(cwd: string) {
  if (!fs.existsSync(cwd)) {
    return ERRORS.MISSING_DIR
  }

  // Check for existing components.json file.
  if (fs.existsSync(path.resolve(cwd, 'components.json'))) {
    return ERRORS.EXISTING_CONFIG
  }

  // Check for empty project. We assume if no package.json exists, the project is empty.
  if (!fs.existsSync(path.resolve(cwd, 'package.json'))) {
    return ERRORS.EMPTY_PROJECT
  }

  // Check if the project is a Next.js project.
  if (
    !fs.existsSync(path.resolve(cwd, 'next.config.js')) &&
    !fs.existsSync(path.resolve(cwd, 'next.config.ts')) &&
    !fs.existsSync(path.resolve(cwd, 'next.config.mjs'))
  ) {
    return ERRORS.NON_NEXT_PROJECT
  }

  // We need Tailwind CSS to be configured.
  if (
    !fs.existsSync(path.resolve(cwd, 'tailwind.config.js')) &&
    !fs.existsSync(path.resolve(cwd, 'tailwind.config.ts'))
  ) {
    return ERRORS.TAILWIND_CONFIG_MISSING
  }

  return null
}
